import { client } from "./graphql/client";
import { formatApolloError } from "./graphql/error";
import { findOrderByReferenceQuery, findReferenceByOrderQuery, getOrderQuery } from "./graphql/order/queries";

export const orderDataProvider = {
    getOne: async(resource, params) => {
        try {
            const { orderId } = params;
            if (!orderId) {
                return {
                    data: { id: null },
                    total: 0
                }
            }
            const isReferenceLookup = resource === 'orderReferences';
            const result = await client.query({
                query: isReferenceLookup ? findReferenceByOrderQuery : getOrderQuery,
                variables: {
                    orderId
                },
                fetchPolicy: 'network-only',
                notifyOnNetworkStatusChange: true
            });
            const resultKey = isReferenceLookup ? "findReferenceByOrder_Admin" : "order_Admin";
            const order = result.data[resultKey]
            const data = (() => {
                if (isReferenceLookup) {
                    if (order) {
                        return { id: order.orderId, ...order };
                    }
                    return { id: orderId, reference: null };
                } else {
                    if (order) {
                        return { id: order.id || order.orderId || orderId, ...order };
                    }
                    return { id: orderId };
                }
            })();
            return {
                data,
            }
        } catch (e) {
            return Promise.reject({
                error: formatApolloError(e),
                data: [],
                total: 0
            });
        }

    },

    getManyReference: async(resource, params) => {
        try {
            const { reference } = params;
            if (!reference) {
                return {
                    data: [],
                    total: 0
                }
            }
            const result = await client.query({
                query: findOrderByReferenceQuery,
                variables: {
                    reference
                },
                fetchPolicy: 'network-only',
                notifyOnNetworkStatusChange: true
            });
            const results = result.data["findOrderByReference_Admin"]
            return {
                data: results,
                total: results.length
            }
        } catch (e) {
            return Promise.reject({
                error: formatApolloError(e),
                data: [],
                total: 0
            });
        }
    }
}
